import { useLocationEffect } from 'hooks/useLocation'

export const useLocationUpdateListener = (): void => {
  useLocationEffect(() => {
    window.scrollTo(0, 0)
  })
}
